import React from "react";
import statut from '../other/Statut_SNF.pdf';
import goals from '../other/Cele-stowarzyszenia.pdf';
import styles from '../Styles/about.css';

function About() {
    return(
        <div className="aboutWrapper">
            <div className="anotherWrapper">
                <h1 className="btt">O nas: </h1>
                <a className="black">Kornik to prastara gazetka I Liceum redagowana przez uczniów, których rozpiera pasja do dziennikarstwa. Najbardziej interesujące wydarzenia w szkole, ciekawostki, kontrowersyjne opowieści – to właśnie to, co kochamy najbardziej! Dla Was badamy i przedstawiamy najróżniejsze sprawy w naszej szkole. Zachęcamy do czytania naszej gazetki!</a>
            </div>
        </div>
    );
}

export default About;